import { api } from "@/lib/api"

/**
 * Los saldos que vienen del periodo anterior.
 *
 *   GET  /api/filings/arrastres        ?entity_id&anio
 *   POST /api/filings/arrastres        uno
 *   POST /api/filings/arrastres/lote   los cinco de un periodo
 *
 * SIN MOCK: esto cambia el impuesto a pagar de una declaracion que alguien va a
 * firmar. Un mock que devuelve saldos plausibles es lo unico que no se puede
 * permitir aqui.
 */

export interface Arrastre {
  id: string
  entity_id: string
  razon_social: string
  periodo: string
  codigo: string
  nombre: string
  importe: number | string
  moneda: string
  /** `apertura` = se declaro que NO venia nada. Distinto de no declarar. */
  origen: "declarado" | "apertura" | "calculado"
  motivo: string
  declarado_por: string | null
}

export interface ConceptoArrastre {
  codigo: string
  nombre: string
  /** Que casilla mueve y como. Son cinco vias distintas de bajar el impuesto. */
  efecto: string
  donde: string
}

export function fetchArrastres(entityId?: string, anio?: number): Promise<{
  arrastres: Arrastre[]
  conceptos: ConceptoArrastre[]
  faltantes: { entity_id: string; razon_social: string; periodo: string; comprobantes: number }[]
  nota: string
}> {
  return api.get("/filings/arrastres", {
    query: { entity_id: entityId || undefined, anio },
  })
}

export function declararArrastres(payload: {
  entity_id: string
  periodo: string
  importes: Record<string, number>
  motivo: string
}): Promise<{ declarados: number; periodo: string }> {
  return api.post("/filings/arrastres/lote", payload)
}
